import React from 'react';
import EmenuPlaceholder from '../EmenuPlaceholder';
import { formatMillisecondsToTime } from '../utils';

interface EmenuPosterBadgeProps {
  containerClassName: string;
  posterClassName: string;
  badgeClassName: string;
  durationClassName?: string;
  playDuration?: number | null;
}

const EmenuPosterBadge: React.FC<EmenuPosterBadgeProps> = ({
  containerClassName,
  posterClassName,
  badgeClassName,
  durationClassName,
  playDuration,
}) => (
  <div className={containerClassName}>
    <EmenuPlaceholder className={posterClassName} />
    <span className={badgeClassName}>e-menu</span>
    {!!durationClassName && !!playDuration && (
      <span className={durationClassName}>{formatMillisecondsToTime(playDuration)}</span>
    )}
  </div>
);

export default EmenuPosterBadge;
